import React from 'react';
import '@/styles/ipe/workbench/components/TechTaskProgressBar.css';

/**
 * 浅色科技感任务进度条（处理中 / 已完成 / 失败）
 * @param {{ percent?: number, variant?: 'processing'|'success'|'error', className?: string }} props
 */
export default function TechTaskProgressBar({
  percent = 0,
  variant = 'processing',
  className = '',
}) {
  const safePercent = Math.max(0, Math.min(100, Number(percent) || 0));
  const fillVariant = ['processing', 'success', 'error'].includes(variant) ? variant : 'processing';

  return (
    <div
      className={`tech-progress-track${className ? ` ${className}` : ''}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={safePercent}
    >
      <div
        className={`tech-progress-fill tech-progress-fill--${fillVariant}`}
        style={{ width: `${safePercent}%` }}
      />
    </div>
  );
}
